import { render, staticRenderFns } from "./sanctionSearchresult.vue?vue&type=template&id=69008f14"
import script from "./sanctionSearchresult.vue?vue&type=script&lang=js"
export * from "./sanctionSearchresult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports